import { AppLayout } from "./AppLayout.jsx";
import { useUrlRouting } from "./logic/routing/useUrlRouting.js";

export default function App() {
  useUrlRouting();
  return <AppLayout />;
}
